import {useQuery} from '@tanstack/react-query';

import {fetchNewsUnreadCount} from 'api/news';

const NEWS_SEEN_KEY = 'news_last_seen_at';

export const getNewsLastSeenAt = () => localStorage.getItem(NEWS_SEEN_KEY);

export const markNewsAsSeen = () => {
    localStorage.setItem(NEWS_SEEN_KEY, new Date().toISOString());
};

export function useNewsUnreadCount() {
    const since = getNewsLastSeenAt();

    const { data: count = 0 } = useQuery({
        queryKey: ['news-unread-count', since],
        queryFn: () => fetchNewsUnreadCount(since),
        staleTime: 5 * 60 * 1000,
    });

    return count;
}
